import { OneDrive } from './../../../dms/onedrive/onedrive.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, NgZone, HostListener, AfterContentChecked, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IdexService } from 'app/idex.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MatLegacyOption as MatOption } from '@angular/material/legacy-core';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UploadFilesComponent } from 'app/dms/upload-files/upload-files.component';
import { Toast } from 'app/shared/toast/toast';
import { TranslateService } from '@ngx-translate/core';
import { PreviewDocumentDialogComponent } from '../preview-document-dialog/preview-document-dialog.component';
import { Observable } from 'rxjs';
import { ExportTaskDialogComponent } from '../../export-task-dialog/export-task-dialog.component';
import { EformAPI } from '../../../e-form/e-form.api';
import { MatLegacyAutocomplete as MatAutocomplete } from '@angular/material/legacy-autocomplete';
import { ActivatedRoute } from '@angular/router';
import { DatePipe, formatDate } from '@angular/common';
import { SelectFileDocumentComponent } from '../select-file-document/select-file-document.component';
import { map, startWith } from 'rxjs/operators';
import { Buffer } from 'buffer';
import { SocialLogin } from 'app/account/social-login';
import { EformService } from 'app/e-form/service/eform.service';
import { MomentPipe } from 'app/shared/moment.pipe';
import { FormGenerateComponent } from 'app/e-form/form-generate/form-generate.component';
import { TaskAttribute } from '../../create-task/create-task.type';

declare var $: any;
declare var google: any;

export const PICK_FORMATS = {
   parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
   display: {
      dateInput: 'input',
      monthYearLabel: { year: 'numeric', month: 'short' },
      dateA11yLabel: { year: 'numeric', month: 'numeric', day: 'numeric' },
      monthYearA11yLabel: { year: 'numeric', month: 'long' }
   }
}

class PickDateAdapter extends NativeDateAdapter {
   format(date: Date, displayFormat: Object): string {
      if (displayFormat === 'input') {
         return formatDate(date, 'dd/MM/yyyy', this.locale);
      } else {
         return date.toDateString();
      }
   }
}

@Component({
   selector: 'app-upload-document',
   templateUrl: './upload-document.component.html',
   styleUrls: ['./upload-document.component.css'],
   providers: [DatePipe,
      { provide: MAT_DATE_LOCALE, useClass: PickDateAdapter },
      { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
   ]
})
export class UploadDocumentComponent implements OnInit, AfterContentChecked {
   @Input() typeName: string;
   @Input() taskAttribute: TaskAttribute;
   @Input() data: any;
   @Input() search = false;
   @Input() tin;
   @Input() link = '';
   @Input() idFolderExport: string;
   @Input() show = true;
   @Output() changeTemplate = new EventEmitter<number>();
   @Output() searchpos = new EventEmitter<number>();
   @Output() loadmore = new EventEmitter<any>();
   @Output() setNameTask = new EventEmitter<any>();
   @Output() setNameCertificate = new EventEmitter<any>();
   @Output() changeForm = new EventEmitter<number>();
   @ViewChild('certificateOrg') cerOrg: any;
   @ViewChild('certificatePer') cerPer: any;
   @ViewChild('certificateOrgDesc') cerOrgDesc: ElementRef;
   @ViewChild('certificateOrgDes') cerOrgDes: ElementRef;
   @ViewChild('certificateType') cerType: ElementRef;
   @ViewChild('siteNameList') siteNameList: ElementRef;
   @ViewChild('contTemplate') contTemplate: ElementRef;

   myControlTemplate = new FormControl<string | TemplateData>('');
   @ViewChild('matAutocompleteFormName') matAutocomplete: MatAutocomplete;
   @ViewChild('formNameOpt') formNameOpt: MatOption;
   @ViewChildren('formNameOpt') matOptions: QueryList<MatOption>;
   private chunkSize = 1048576;
   public uploadAttribute = {
      taskId: '',
      template: '',
      dueDate: '',

   };
   public doclists = [];
   public doclist = {
      docId: '',
      docName: '',
      totalPages: '',
      signItems: [],
      isDocList: false
   };

   public docDeleted: string[] = [];
   public docNew: string[] = [];
   public files = [];
   public taskName;
   public taskId = 0;
   public template;
   public dueDate;
   public dueDateObject: Date;
   public priority;
   public documents: any;
   public index_old: any = -1;
   public isDocList = false;
   public backupIdFolderExport;
   public backupPathExport;
   public isExport: boolean;
   public isSignDate: boolean;
   public isEndDate: boolean;
   public errorSignDate = false;
   public errorDocDate = false;
   public errorPeriod = false;
   public dayLeft = 1;
   public deletDayleft = 1;
   public dateEnd: Date;
   public exportOption = 'N';
   public dateEndOption = 'R';
   public isExportPathChange = false;
   public isResend = false;
   public userEmail: any;
   public certificateOrgList: any[] = [];
   error: string;
   fieldTypeName: string;
   isTask: boolean;
   errorMessage: any;
   public selectSiteName = {
      tin: '',
      name: '',
   };
   mimetype = [];
   templatesList: Observable<TemplateData[]>;
   templates: TemplateData[] = [];
   object_file: any;
   items: any[];
   info: any;
   formName: any;
   filteredListForm = [];
   listForm = [];
   draft: any;
   publish: any;
   filterValue = '';
   formNameControl = new FormControl();
   formDateEndControl = new FormControl({value: '' , disabled: true});
   formDayEndControl = new FormControl();
   formDocEndControl = new FormControl();
   currentDate = new Date();
   minSelectDate = new Date();
   private _currentIndexTemplate = -1;
   watermark: any;
   public selectTemplate = true;
   lang = 'th';
   siteId;
   siteName = '';
   private _progressDlg: MatDialogRef<UploadFilesComponent>;
   private exportDialog: MatDialogRef<ExportTaskDialogComponent>;
   private path: string;
   @ViewChild('contactOptTemplate') contactOptTemplate: MatOption;
   certificateForm = new FormGroup({
      organizationControl: new FormControl('', [Validators.required]),
      personalControl: new FormControl('', [Validators.required])
   });
   selectedValueOrg: any;
   selectedValuePer: any;
   public firstIndex = {
      tin: 'My Files',
      name: 'My Files',
   };
   checkcertList: string;
   ischeckCertOrg: boolean;
   ischeckCertPer: boolean;
   pathSite: string;
   certificateHeader: string;
   certificatePerList: any[] = [];

   certList = [ /// certificate code ZE-1575
      { value: 'ZDOX', viewValue: 'choose-certificate.zdox_certificate' },
      { value: 'STCA', viewValue: 'choose-certificate.site_certificate' },
      { value: 'ISCA', viewValue: 'choose-certificate.individual_certificate' },
      { value: 'IDCA', viewValue: 'choose-certificate.individual_certificate_ca' }
   ];
   myControlSite = new FormControl<string | Site>('');
   myControlSelectSite = new FormControl<string | Site>('');
   filteredOptions: Observable<Site[]>;
   siteList: Site[] = [];
   site_name: any;
   @ViewChild('fileUpload') fileUpload: ElementRef;
   @ViewChild('fileUploadTemplate') fileUploadTemplate: ElementRef;
   private selectFile: MatDialogRef<SelectFileDocumentComponent>;

   constructor(public service: IdexService, public dialog: MatDialog,
      public toast: Toast,
      private translate: TranslateService,
      private dateAdapter: DateAdapter<any>,
      private api: EformAPI,
      private route: ActivatedRoute,
      private socialLogin: SocialLogin,
      private zone: NgZone,
      private eFormService: EformService,
      private cdref: ChangeDetectorRef) {
         this.service.loadFileMaxUpload();
   }

   ngAfterContentChecked(): void {
      this.cdref.detectChanges();
   }

   ngOnInit() {
      this.userEmail = this.service.user.email;
      if (this.typeName === 'startFlow') {
         // ⚠️ บรรทัดนี้ทำให้ 'this.mimetype' ไม่ sync กับ 'this.files'. ควร refactor.
         this.mimetype.push({ type: 'application/pdf', size: 0 });
      }
      this.docNew = [];
      this.doclists = this.taskAttribute.docList;
      this.dueDateObject = new Date(this.taskAttribute.dueDate);
      if (this.taskAttribute.templateId) {
         this.service.getTemplate(this.taskAttribute.templateId)
            .subscribe((data) => {
               this.taskAttribute.apvLevel = data.apvLevel;
               if (data.link) {
                  this.taskAttribute.idFolderExport = data.idFolderExport
                  this.taskAttribute.exportPath = data.link;
                  this.link = data.link;
                  this.idFolderExport = data.idFolderExport;
                  this.isExport = true;
               }
               this.setSignItems(data);
            },
               (err) => {
                  console.error(err);
               });
      }
      this.translate.get('langCurrent').subscribe((msg) => {
         if (msg === 'th') {
            this.dateAdapter.setLocale('th-TH');
            this.lang = 'th';
         } else if (msg === 'en') {
            this.dateAdapter.setLocale('en-GB');
            this.lang = 'en';
         } else if (msg === 'cn') {
            this.dateAdapter.setLocale('zh-CN');
            this.lang = 'cn';
         }
      });
      this.backupIdFolderExport = this.idFolderExport;
      this.backupPathExport = this.link;
      this.getWatermark();
      this.getCertificate();
      this.filteredListForm = undefined;
      this.translate.get('eform.status.publish').subscribe(s => {
         this.publish = s;
      });
      this.translate.get('eform.status.draft').subscribe(s => {
         this.draft = s;
      });
      if (this.service.user.business && this.service.user.business.length !== 0) {
         this.siteList = this.service.user.business;
         this.siteList = [this.firstIndex].concat(this.siteList);
      } else {
         this.siteList = [this.firstIndex].concat(this.siteList);
      }
      this.getTemplate();
      this.getForm();
   }

   getTemplate(){
      this.service.listTemplate(true, this.taskAttribute.siteId)
         .subscribe((data) => {
            this.templates = data;
            this.templatesList = data;
            this.filterTemplateChanger();
         });
   }

   getForm(){
      if (this.siteId || this.taskAttribute.siteId) {
         this.service.getBusinessSiteBySiteCode(this.siteId ? this.siteId : this.taskAttribute.siteId).subscribe(rs => {
            this.api.listFormTin('All',false,rs?.tin,true)
            .subscribe(data => {
               if(data) {
                  this.listForm = data;
                  this.filteredListForm = data;
               } else {
                  this.listForm = [];
                  this.filteredListForm = [];
               }
            });
         });
      } else {
         this.listForm = [];
         this.filteredListForm = [];
      }

   }

   setCertificate() {
   if (this.siteList && this.siteList.length > 1) {
      if (this.siteList.length === 2) {
         this.myControlSite.setValue({ name: this.siteList[1].name, tin: this.siteList[1].tin })
         this.myControlSelectSite.setValue({ name: this.siteList[1].name, tin: this.siteList[1].tin })
         this.taskAttribute.siteId =  this.siteList[1].tin;
         this.selectSiteName = this.siteList[1];
         this.onOptionSelected(this.siteList[1]);
         this.setSitewithCertificateTask(this.siteList[1].tin);
      } else {
         this.checkcertList = '1';
         this.cerOrg.disabled = true;
      }
   } else {
      this.setDefaultSite();
   }
      this.filterSiteChanger();
   }

   setDefaultSite(){
      this.myControlSite.setValue({ name: this.siteList[0].name, tin: this.siteList[0].tin })
      this.myControlSelectSite.setValue({ name: this.siteList[0].name, tin: this.siteList[0].tin })
      this.taskAttribute.siteId = this.siteList[0].tin;
      this.selectSiteName = this.firstIndex;
      this.onOptionSelected(this.siteList[0]);
      this.setSitewithCertificateTask(this.siteList[0].tin);
   }

   displayFn(site: Site): string {
      return site && site.name ? site.name : '';
   }

   private _filterSite(name: string): Site[] {
      const filterValue = name.toLowerCase();
      return this.siteList.filter(siteLists => siteLists.name.toLowerCase().includes(filterValue));
   }


   getCertificate() {
      this.service.get('cert/list')
         .subscribe((data) => {
            if (data) {
               this.certificateOrgList = data;
            }
            if (this.typeName !== 'startFlow') {
               this.setCertificate();
            }
         }, error => {
            this.toast.error(error.massage);
         });
   }

   getWatermark() {
      if (!this.siteId) {
         this.siteId = this.taskAttribute.siteId;
      }
      this.service.getWatermark('PDFTron', this.siteId).subscribe((data) => {
         this.watermark = data;
      });
   }

   getMimetype(doc: any) {
      for (let i = 0; i < doc.length; i++) {
         // ⚠️ บรรทัดนี้ทำให้ 'this.mimetype' ไม่ sync กับ 'this.files'. ควร refactor.
         this.mimetype.push(doc[i]);
      }
   }

   listTemplate() {
      this.service.listTemplate(false)
         .subscribe((data: any) => {
            this.templatesList = data;
         }, error => {
            this.errorMessage = error;
         });
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items) {
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               hasFiles = true;
               break;
            }
         }
      } else if (data.files && data.files.length > 0) {
         hasFiles = data.files && data.files.length > 0;
      }

      if (hasFiles) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
         $('#divUpload').addClass('drag-over');
      }
   }

   async onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      $('#divUpload').removeClass('drag-over');
      const data = event.dataTransfer;
      let files;
      if (data.items) {
         files = [];
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               const temp = data.items[i].getAsFile();
               let ext = temp.type;
               if (ext === '') {
                  ext = temp.name.split('.').pop();
                  if (ext.toLowerCase() === 'zdox'){
                     const file = await this.getFileZdox(temp);
                     files.push(file);
                  }
               }
               else {
                  files.push(data.items[i].getAsFile());
               }
            }
         }
      } else {
         files = data.files;
      }
      if (files.length > 0) {
         this.loadImage(files);
      }
   }

   async getFileZdox(temp: File): Promise<File> {
      class ZdoxFile extends File {
         constructor(fileBits: BlobPart[], fileName: string) {
             super(fileBits, fileName, {'type': 'zdox', lastModified: Date.now()});
         }
      }
      const content = await this.readFile(temp);
      const blobParts: BlobPart[] = [content];
      const zdoxFile = new ZdoxFile(blobParts, temp.name);
      return zdoxFile;
   }

   readFile(file: File): Promise<string | ArrayBuffer | null> {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
          reader.readAsArrayBuffer(file);
      });
  }


   onDragLeave() {
      $('#divUpload').removeClass('drag-over');
   }

   loadImage(myFile: any): void {
      if (myFile.length === 0) {
         return;
      }

      this.uploadDoc(myFile);
   }

   validateFile(myFile: any,flagValidateTotalDocument?:boolean) {
      const $input = $('input[type=file]');
      if (this.eFormService.validateZdoxOneFile(myFile, this.taskAttribute.docList)) {
         this.translate.get('uploadDoc.errorOneForm').subscribe(s => {
            this.toast.error(s);
         });
         return false;
      }

      if(flagValidateTotalDocument) return true;


      for (let i = 0; i < myFile.length; i++) {
         if (myFile[i] != null) {
            let ext = myFile[i].type;
            if (ext !== '') {
               if (/[/\\:*?"<>|%]/.test(myFile[i].name)) {
                  this.translate.get('alert.create_folder_error').subscribe(s => {
                     this.toast.error(s);
                  });
                  return false;
               }
               if (this.validateExtension(ext) === false) {
                  $input.val('');
                  $input.attr('title', window.URL ? ' ' : '');
                  this.handleToastError('uploadDoc.errorPdf');
                  return false;
               } else {
                  if (myFile[i].size > this.service.fileMaxUpload) { // 2097152
                     $input.val('');
                     $input.attr('title', window.URL ? ' ' : '');
                     this.translate.get('uploadDoc.errorFileSize', {size: this.service.getFileMaxUploadMB()}).subscribe(s => this.toast.error(s));
                     return false;
                  }
               }
            } else {
               $input.val('');
               $input.attr('title', window.URL ? ' ' : '');
               this.handleToastError('uploadDoc.errorPdf');
               return false;
            }
         }
      }
      return true;
   }

   validateExtension(v) {
      let allowedExtensions: string[];
      if (this.typeName === 'template') {
         allowedExtensions = ['application/pdf', 'text/xml', 'zdox', 'application/octet-stream'];
      } else {
         allowedExtensions = ['image/bmp', 'application/msword', 'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/jpeg', 'image/png', 'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'text/plain', 'image/tiff', 'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.oasis.opendocument.text',
            'zdox', 'text/xml', 'application/octet-stream'];
      }
      for (let ct = 0; ct < allowedExtensions.length; ct++) {
         const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
         if (fileSelected !== -1) {
            return true;
         }
      }
      return false;
   }

   disableSelectForm(): boolean {
      return this.taskAttribute.docList.filter(f => f.docName?.endsWith('.zdox') || f.type === 'text/xml').length > 0 || this.filteredListForm?.length === 0;
   }

   delImage() {
      const divControl = $('#divShowImg');
      divControl.remove();
      $('#divUpload').show();
   }

   async onSelectFiles(input: any) {
      if (input.files.length === 0) {
         return;
      }
      const temp = input.files;
      const files = [];
      let countForm = 0;
      for(let i = 0; i < temp.length; i++) {
         let ext = temp[i].type;
         if (ext === '') {
            ext = temp[i].name.split('.').pop();
            if (ext.toLowerCase() === 'zdox'){
               countForm++;
               if (countForm > 1 || this.taskAttribute.isFormStartFlow || this.taskAttribute.formName) {
                  this.translate.get('uploadDoc.errorOneForm').subscribe(s => {
                     this.toast.error(s);
                  });
                  return;
               }
               const file = await this.getFileZdox(temp[i]);
               files.push(file);
            }
         } else {
            files.push(temp[i]);
         }
      }

      if (this.validateFile(files)) {
         for (let loopFile = 0; loopFile < files.length; loopFile++) {
            files[loopFile].fullPath = files[loopFile].webkitRelativePath;
            const file: any = files[loopFile];
            if (/[<|>\\\/:?*"]/g.test(file.name)) {
               this.translate.get('alert.create_folder_error').subscribe(s => {
                  this.toast.error(s);
               });
               return;
            }
         }
      }

      this.uploadDoc(files);
   }

   private init(loopFile: any): Observable<any> {
      return this.service.get('/init/upload/' + loopFile);
   }

   private failedUploadNames: string[] = [];
   private failedUploadTimer: any;

   /**
    * อัปโหลดไม่สำเร็จ (เช่น disk ของ server เต็ม): เอาไฟล์ออกจากรายการที่รอ (spinner) ไม่อย่างนั้นค้างตลอด
    * และไปขั้นถัดไปไม่ได้ (create-task เช็ค object_file.length > 0) แล้วแจ้ง error รวมครั้งเดียวพร้อมชื่อไฟล์
    */
   private uploadFailed(file: any, error?: any) {
      file.error = error?.message || error;
      if (this.object_file) {
         const index = this.object_file.indexOf(file);
         this.object_file.splice(index >= 0 ? index : 0, 1);
         if (this.object_file.length === 0) {
            const $input = $('input[type=file]');
            $input.val('');
            $input.attr('title', window.URL ? ' ' : '');
            this.object_file = null;
         }
      }
      this.failedUploadNames.push(file.name);
      clearTimeout(this.failedUploadTimer);
      this.failedUploadTimer = setTimeout(() => {
         const names = this.failedUploadNames;
         this.failedUploadNames = [];
         const shown = names.slice(0, 3).join(', ') + (names.length > 3 ? ' +' + (names.length - 3) : '');
         this.translate.get('uploadDoc.errorUploadFailed', {name: shown}).subscribe(s => this.toast.error(s));
      }, 500);
   }

   uploadDoc(files: any) {
      if (this.validateFile(files)) {
         if (this.object_file === undefined || this.object_file === null) {
            this.object_file = [];
         }
         for (let loopFile = 0; loopFile < files.length; loopFile++) {
            files[loopFile].fullPath = files[loopFile].webkitRelativePath;
            this.object_file.push(files[loopFile]);
            const file: any = files[loopFile];
            this.init(loopFile).subscribe(result => {
               const key = result.key;
               const fileNo = result.fileNo;
               let offset = 0;
               const xhr = new XMLHttpRequest();
               const send = () => {
                  const end = Math.min(offset + this.chunkSize, file.size);
                  xhr.open('PUT', this.service.url + '/upload/' + key, true);
                  xhr.setRequestHeader('x-auth-token', this.service.user.token);
                  xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + file.size);
                  const blob = file.slice.call(file, offset, end);
                  xhr.send(blob);
               };
               xhr.onload = () => {
                  if (xhr.status === 308) {
                     if (file.canceled) {
                        this.service.post('/cancel/upload/' + key, null).subscribe(() => {
                           // This is intentional.
                        },
                           (err) => {
                              console.error(err);
                           });
                        return;
                     }
                     offset += this.chunkSize;
                     send();
                  } else if (xhr.status === 201) {
                     this.finish(key, '', file, '', fileNo, '');
                  } else {
                     this.uploadFailed(file, xhr.statusText || ('HTTP ' + xhr.status));
                  }
               };
               xhr.onerror = () => this.uploadFailed(file, 'Network error');
               send();
            }, error => {
               this.uploadFailed(file, error);
            });
         }
      }
   }

   finish(key: string, path: string, file: any, tin: string, loopFile: any, id?: string) {
      const body = {
         name: file.fullPath || file.name,
         destination: path,
         mimeType: file.type,
         tin: tin,
         id: id
      };
      this.service.uploadDocumentTemp(this.typeName, body, loopFile, key).subscribe((response) => {
         const object_file = this.object_file[response.fileIndex];
         const docId = response.docId;
         const docName = response.docName;
         const objectDoclist = {
            docId: '',
            docName: '',
            totalPages: '',
            originalName: '',
            signItems: [],
            isDocList: false,
            isUpload: true,
            isForm: false,
         };
         objectDoclist.docId = docId;
         objectDoclist.docName = docName;
         objectDoclist.originalName = body.name;
         if (this.documents) {
            if (this.documents.docList[0]) {
               if (this.documents.docList[0].signItems && file.type === 'application/pdf') {
                  objectDoclist.signItems = this.documents.docList[0].signItems.slice();
               }
            }
         }
         this.docNew.push(docId);
         if (file.type.toLowerCase() === 'zdox' || file.name.endsWith('.zdox')) {
            this.changeForm.emit(file.name);
            this.taskAttribute.formName = file.name;
            this.taskAttribute.isFormStartFlow = true;
            objectDoclist.isForm = true;
            this.taskAttribute.formList = {
               formName: file.name,
               formType: 'NF'
            };
            this.taskAttribute.docList.unshift(objectDoclist);
            this.mimetype.unshift(file)
            this.files.unshift({ object_file, docId, docName });
         } else {
            this.taskAttribute.docList.push(objectDoclist);
            this.mimetype.push(file);
            this.files.push({ object_file, docId, docName });
         }
         this.object_file.splice(0, 1);
         if (this.object_file.length === 0) {
            const $input = $('input[type=file]');
            $input.val('');
            $input.attr('title', window.URL ? ' ' : '');
            this.object_file = null;
         }
      }, error => {
         this.uploadFailed(file, error);
      });
   }

   deleteFile(index: any) {
      // ZE-5204:
      // if เช็ค isUpload นี้เป็นการแก้ไขที่ปลายเหตุสำหรับปัญหา taskAttribute.docList ไม่ sync กับ this.files และ this.mimetype (ที่มีไว้เพื่อเก็บข้อมูลไฟล์ที่จะถูกอัปโหลด)
      // แก้โดยให้ลบข้อมูลใน this.files และ this.mimetype เฉพาะไฟล์ที่ถูกอัปโหลดเท่านั้น
      // ถ้าลบไฟล์ zDOX Form ที่ไม่ได้ถูกอัปโหลด จะไม่ลบอะไรใน this.files และ this.mimetype
      //
      // ปัญหา:
      // เมื่อเพิ่มฟอร์มผ่านการเลือก (ไม่ใช่อัปโหลด) ฟอร์มจะถูกเพิ่มเข้า docList ในตำแหน่ง index = 0 แต่จะไม่ถูกเพิ่มใน this.files กับ this.mimetype
      // ส่วน PDF ที่ถูกอัปโหลด จะไปอยู่ที่ index = 1 เป็นต้นไปใน docList แต่จะอยู่ที่ index = 0 ใน this.files กับ this.mimetype
      // ตอนจะลบฟอร์มด้วย method นี้ จะใช้แค่ index ในการสั่งลบ ทำให้มันไปลบไฟล์ PDF ที่ถูกเก็บใน this.files กับ this.mimetype ด้วย
      // จากในโค้ดในส่วนของการส่งงาน (ใน create-task component) หนึ่งในเงื่อนไขที่จะทำให้ enable ปุ่มกด Send ส่งงานได้ คือ ถ้ามีไฟล์ PDF ที่ถูกอัปโหลด ตัวแปร mimeType ก็ต้องมีค่าไฟล์
      // ดังนั้น เมื่อลบฟอร์มที่ไม่ได้ถูกอัปโหลด จะทำให้ mimeType ที่เก็บค่าไฟล์ที่ถูกอัปโหลดโดนลบไป ทำให้ไม่สามารถกด Send ได้
      //
      // Suggestion:
      // - หาทางให้ this.files กับ this.mimetype เก็บ id ของไฟล์ด้วย
      //   แล้วเมื่อลบฟอร์มที่ไม่ได้ถูกอัปโหลด ให้ลบ id ของไฟล์นั้นออกจาก this.files กับ this.mimetype แทนการใช้ index
      // - refactor this.files กับ this.mimetype ให้มันเก็บในตัวแปรเดียวกันเลยก็ดี เช่น
      //   this.uploadedFiles: {docId: string, file: File, mimetype: Object}[] = [ { docId: '123', file: [...], mimetype: {...} }, ... ]
      //   (ไม่รู้มีเคสไหนที่ this.files กับ this.mimetype ไม่ตรงกันบ้างไหม? ถ้าไม่มี ก็น่าจะเก็บรวมกันในตัวแปรเดียวกันไปเลย หรือเก็บรวมไปกับ taskAttribute เลยก็ได้ ง่ายดี)
      // - แก้ชื่อ จาก mimetype เป็น fileProperties หรืออะไรก็ได้ที่เหมาะสมด้วย เพราะมันเป็น Object ที่มีมากกว่าแค่ mimeType
      if (this.taskAttribute?.docList[index]?.isUpload) {
         this.mimetype.splice(index, 1);
         this.files.splice(index, 1);
      }

      const docId = this.taskAttribute.docList[index].docId;
      if (!(this.taskAttribute.docList[index].isDocList === true)) { // เช็คไฟล์ที่ไม่ได้มาจากการ Upload

         if(this.taskAttribute.docList[index].isUpload) {
         this.service.deleteDocument(docId)
         .subscribe((response) => {
            if (localStorage.getItem('newTempId') !== null) {
               localStorage.removeItem('newTempId');
            }
            // This is intentional.
         },
            (err) => {
               this.toast.error(err)
            });
         }else{
            this.docDeleted.push(docId)
         }
      }

      const doc = this.taskAttribute.docList[index];
      const ext = doc.docName.split('.').pop();
      if (ext.toLowerCase() === 'zdox' || this.taskAttribute.docList[index].isSelectForm) {
         this.taskAttribute.isFormStartFlow = false;
         this.taskAttribute.formName = '';
      }
      this.taskAttribute.docList.splice(index, 1);
      this.changeTemplate.emit(index);
   }

   submitDeleteFile() {
      for (let i = 0; i < this.docDeleted.length; i++) {
         this.service.deleteDocument(this.docDeleted[i])
            .subscribe((response) => {
               // This is intentional.
            },
               (err) => {
                  console.error(err);
               });
      }
   }

   async onClickListItem(docId, docName, index, mimetype, size) {
      const isForm = docName.slice(-4) === 'zdox' || this.taskAttribute?.formName === docName;
      let formSections;
      if (isForm) {
         formSections = await this.getFormData(docId);
      }
      $('#mat_list_' + index).css('background-color', '#edeeef');
      this.checkIndex(index);
      if (isForm) {
         this.openPreview()
      } else {
         const dialogRef = this.dialog.open(PreviewDocumentDialogComponent, {
            disableClose: true,
            height: '630px',
            width: '1050px',
            data: { service: this.service, docId: docId, docName: docName, mimetype: mimetype, size: size, show: this.show, watermark: this.watermark}
         });
         dialogRef.afterClosed().subscribe(result => {
            // This is intentional.
         });
      }

   }

   getFormData(docId): Promise<any> {
      this.eFormService.initailization();
      const _transformDate = new MomentPipe();
      return this.api.getEFormFormDocId(docId).toPromise().then((res) => {
         const data = res.body.data;
         this.eFormService.eForm.controls.original.setValue(this.lang);
         this.eFormService.formValue.id = data.formId;
         this.eFormService.formValue.docId = docId;
         this.eFormService.formValue.original = this.lang;
         this.eFormService.formValue.lastUpdate = {when: _transformDate.transform(data.lastUpdate)};
         this.eFormService.formValue.version = data.version;

         this.eFormService.storeMetaField(data.formName, data.key);
         this.eFormService.storeSection(data.sections);
         this.eFormService.storeValue(data.value ?  JSON.parse(data.value) : '');
         if (data.value) {
            this.eFormService.formValue.value = JSON.parse(data.value);
         }
         return res.body.data.sections;
      });
   }

   openPreview() {
      const formInfo = this.eFormService.eForm.value;
      const dialogRef = this.dialog.open(FormGenerateComponent, {
         disableClose: true,
         data: {
            formId: '',
            formInfo: formInfo,
            previewClass: true
         },
         panelClass: ['my-dialog', 'pointer-event-none'],
         width: 'auto',
         height: 'auto',
         minWidth: '520px',
      });

      dialogRef.componentInstance.isPreview = true;
   }

   checkIndex(index) {
      if (this.index_old === -1) {
         this.index_old = index;
      } else if (index !== this.index_old) {
         $('#mat_list_' + this.index_old).css('background-color', '#FFFFFF');
         this.index_old = index;
      }
   }

   onChangeDate($event) {
      const date = this.dueDateObject.getDate();
      const month = this.dueDateObject.getMonth() + 1;
      const year = this.dueDateObject.getFullYear();
      this.taskAttribute.dueDate = new Date(year + '-' + month + '-' + date);
   }

   onTemplateChange(template: any) {
      let share = false;

      if (template.createBy !== this.userEmail && template) {
            share = true;
         }
         if (template.templateId) {
            this.service.getTemplate(template.templateId, share)
               .subscribe((data) => {
                  this.selectTemplate = true;
                  this._currentIndexTemplate = template.templateId;
                  this.taskAttribute.templateId = data.templateId;
                  this.taskAttribute.workflowId = data.workflowId;
                  this.taskAttribute.apvLevel = data.apvLevel;
                  this.taskAttribute.templateName = template.templateName;
                  this.taskAttribute.siteId = data.siteId;

                  this.changeSelectSite();

                  if(data.link){
                     this.isExport = true;
                     this.link = data.link;
                     this.idFolderExport = data.idFolderExport;
                     if (this.typeName === 'startFlow' || this.isResend) {
                        if (this.backupIdFolderExport !== data.idFolderExport) {
                           this.isExportPathChange = true;
                           this.exportOption = 'M';
                        } else {
                           this.isExportPathChange = false;
                           this.exportOption = 'E';
                        }
                     }
                  } else {
                     this.isExport = false;
                     this.link = '';
                     this.idFolderExport = '';
                     this.isExportPathChange = false;
                     this.exportOption = 'N';
                  }
                  if(data.dayLeft){ /// set day left
                     this.isSignDate = true;
                     this.dayLeft = data.dayLeft;
                     this.setDateChange();
                  }else if(!data.dayLeft){
                     this.isSignDate = false;
                     this.dayLeft = 1;
                     this.setDateChange();
                  }
                  if(data.retentionPeriod && data.retentionPeriod !== -1){ /// set delete date
                     this.isEndDate = true;
                     this.deletDayleft = data.retentionPeriod;
                     this.setDocDelete();
                  }else if(!data.retentionPeriod || data.retentionPeriod === -1){
                     this.isEndDate = false;
                     this.deletDayleft = 1;
                     this.taskAttribute.retentionPeriod = -1;
                  }
                  if (this.taskAttribute.docList.length !== 0) {
                     this.updateSignItems(data);
                  } else {
                     this.setSignItems(data);
                  }
                  },
                  (err) => {
                     console.error(err);
                     this.errorMessage = err;
                  });
         }

      this.changeTemplate.emit(template.templateId);
   }

   clearSite(){
      this.setCertificateHeader("");
      this.setTaskNameHeader("");
      this.taskAttribute.siteId = null;
      this.siteId = "";
      this.siteName = "";
      this.listForm = [];
      this.filteredListForm = [];
      this.selectSiteName = {
         tin: '',
         name: '',
      };
   }

   clearSelectTemplate(){
      this.taskAttribute.templateName = '';
      this.taskAttribute.templateId = 0;
      this.taskAttribute.workflowId = 0;
      this.taskAttribute.apvLevel = [];
      this.isSignDate = false;
      this.dayLeft = 1;
      this.isEndDate = false;
      this.deletDayleft = 1;
      this.taskAttribute.dueDate = null;
      this.taskAttribute.dayLeft = null;
      for (const document of this.taskAttribute.docList) {
         document.signItems = [];
      }
   }

   clearSelectForm(){
      this.taskAttribute.formList = {};
      this.taskAttribute.formName = '';
      if (this.taskAttribute.docList[0]?.isForm && !this.taskAttribute.docList[0]?.isUpload) {
         this.taskAttribute.docList.splice(0,1);
      }

      const doc = this.taskAttribute.docList.find(o => o?.isForm && o?.isUpload);
      if (doc) {
         this.taskAttribute.formName = doc.docName;
         this.taskAttribute.formList = {
            formName: doc.docName,
            formType: 'NF'
         };
      }
   }

   updateSignItems(data) {
      this.documents = data;
      if (data) {
         let loop = 0;
         for (const document of this.taskAttribute.docList) {
            if (data.docList[0]) {
               if (this.documents.docList[0].signItems && this.documents.docList[0].type === 'application/pdf') {
                  document.signItems = data.docList[0].signItems.slice();
               }
            }
            loop++;
         }
      }
   }

   setSignItems(data) {
      this.documents = data;
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }

   exportPath() {
      if(!this.myControlSelectSite.value){ // set default when no select site
         this.setDefaultSite();
      }
      const r = this.myControlSelectSite.value;
      if (this.siteList) {
         for (let i = 0; i < this.siteList.length; i++) {
            if (r['tin'] === this.siteList[i].tin) { /// ตรวจสอบเงื่อนไขว่าใช้ code tin เดียวกันเพื่อที่จะกำหนด Path
               if (this.siteList[i].name === 'My Files') {
                  this.pathSite = 'Files';
               } else {
                  this.pathSite = this.siteList[i].name;
               }
            }
         }
      }
      this.exportDialog = this.dialog.open(ExportTaskDialogComponent, {
         disableClose: true,
         data: { service: this.service, data: this, toast: this.toast, translate: this.translate, link: this.link }
      });
      this.exportDialog.componentInstance.pathSite = this.pathSite;
      this.exportDialog.componentInstance.zDoxExport = true;
      this.exportDialog.afterClosed().subscribe((result) => {
         if (result) {
            if (this.typeName === 'startFlow' || this.isResend) {
               if (this.backupIdFolderExport !== result.pathId) {
                  this.isExportPathChange = true;
                  this.exportOption = 'M';
               } else {
                  this.isExportPathChange = false;
                  this.exportOption = 'E';
               }
            }
            this.link = result.pathSelect;
            this.idFolderExport = result.pathId;
         }
      });
   }

   onCheckExport(event) {
      if (event.checked) {
         this.exportOption = 'E'; // Export
      } else {
         if (this.typeName !== 'startFlow') {
            this.link = '';
         } else {
            this.link = this.backupPathExport;
         }
         this.taskAttribute.dueDate = null;
         this.isExportPathChange = false;
         this.exportOption = 'N'; // No Export
      }
   }

   focus() {
      return false;
   }

   displayTemplate(template?: TemplateData): string | undefined {
      let templates: any;
      if (template !== null && template !== undefined && template.templateName !== undefined) {
         templates = template ? template.templateName : '';
      } else {
         templates = template ? template : '';
      }
      return template ? templates : '';
   }

   selectKeyPress(event, formNameOpt?: any) {
      if (event.key === 'Enter') {
         return;
      }
      if (formNameOpt) {
         if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
            this.getListForm(formNameOpt.value);
         }
      }

   }

   selectChange(formName: string) {
      if (!formName) {
         setTimeout(() => {
            const opt = document.querySelector('.mat-option') as HTMLElement;
            if (opt) {
               opt.focus();
            }
         },50);
      } else {
         const selectedOpt = this.matOptions.find(option => option.value === formName);
         if (selectedOpt) {
            selectedOpt._getHostElement().scrollIntoView({ behavior: 'auto', block: 'center' });
            selectedOpt._getHostElement().focus();
         };
      }
   }

   onClosedInput(){
      this.service.getBusinessSiteBySiteCode(this.siteId).subscribe(rs => {
         this.api.listFormTin("All", false, rs.tin, true)
         .subscribe(data => {
            if(data) {
               this.listForm = data;
               this.filteredListForm = data;
            } else {
               this.listForm = [];
               this.filteredListForm = [];
            }
         });
      });
   }

   highlightFirstOptionTemplate(event: MouseEvent | PointerEvent | KeyboardEvent, input: string): void {
      if (event instanceof KeyboardEvent && ["ArrowDown", "ArrowUp"].includes(event.key)) {
         return;
      }
      const kw = input.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(kw)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         if (kw.length > 0) {
            this.selectTemplate = false;
            this.service.getTemplateShare(0, 0, '',
               '', encodeURIComponent(kw), 't', 't')
               .subscribe(
                  data => {
                     this.templatesList = data;
                  }, error => {
                     this.errorMessage = error;
                  });
         } else {
            this.selectTemplate = true;
         }
      }
   }

   getListForm(filterValue: string) {
      if(this.siteId){
         filterValue = encodeURIComponent(filterValue.trim());
         let isSearch = true;
         if (filterValue.length === 0) {
            isSearch = false;
            filterValue = "All";
         }
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase();
         this.service.getBusinessSiteBySiteCode(this.siteId).subscribe(rs => {
            this.api.listFormTin(filterValue, isSearch, rs.tin, true)
            .subscribe(data => {
               if(data) {
                  this.listForm = data;
                  this.filteredListForm = data;
               } else {
                  this.listForm = [];
                  this.filteredListForm = [];
               }
            });
         });
      }
   }

   selectContact(evt: any, formNameOpt: any, cont: any): void {
      if (evt.source) {
         if (evt.isUserInput) {
            this.taskAttribute.formName = formNameOpt.formName;
            this.taskAttribute.formList = formNameOpt;
            const objectDoclist = {
               docId: formNameOpt.alfFormId,
               docName: formNameOpt.formName,
               totalPages: '',
               signItems: [],
               isDocList: false,
               isUpload: false,
               isForm: true,
               isSelectForm: true
            };
            let hasForm = false;
            for (let i = 0; i < this.taskAttribute.docList.length; i++) {
               if (this.taskAttribute.docList[i].isForm && !this.taskAttribute.docList[i].isUpload) {
                  this.taskAttribute.docList[i] = objectDoclist;
                  hasForm = true;
                  break;
               }
            }
            if (!hasForm) {
               this.taskAttribute.docList.splice(0, 0, objectDoclist);
            }

            this.changeForm.emit(formNameOpt);
         }
      } else {
         this.filteredListForm = this.listForm;
      }
   }

   onEndDayChange(): void { // เปลี่ยนเวลาตามวันที่เลือก
      this.minSelectDate = new Date();
      if (this.dateEnd.toDateString() === this.currentDate.toDateString()) {//กรณีเลือกวันนี้ปัดวันอยู่แล้วเลยไม่ต้อง +1
         this.dayLeft = 1;
      } else {
         this.dayLeft = Math.ceil((this.dateEnd.getTime() - this.currentDate.getTime()) / (1000 * 3600 * 24) + 1);
      }
      this.errorPeriod = false;
      this.errorSignDate = false;
      const dueDate = new Date(this.dateEnd);
      dueDate.setDate(dueDate.getDate() + 1);//นับวันนี้ด้วย
      this.taskAttribute.dayLeft = this.dayLeft;
      this.taskAttribute.dueDate = dueDate;
   }
   setDateChange(): void { // เปลี่ยนวันตามเวลากรอก
      if (this.dayLeft) {
         if (this.dayLeft == 0) {
            this.dayLeft = 1;
         }
         this.dayLeft = parseFloat(String(this.dayLeft));
         let day = this.dayLeft;
         var date = new Date();
         day = day - 1;//นับวันนี้ด้วยเลย -1
         date.setDate(this.currentDate.getDate() + day);
         this.dateEnd = date;
         this.dateEnd.setHours(0);
         if(this.isSignDate) {
            this.taskAttribute.dueDate = new Date(this.dateEnd);
            this.taskAttribute.dueDate.setDate(this.dateEnd.getDate() + 1);
            this.taskAttribute.dayLeft = this.dayLeft;
         }
         this.errorSignDate = false;
         this.errorPeriod = false;
      } else {
         this.dayLeft = null;
         this.dateEnd = null;
         this.taskAttribute.dayLeft = null;
         this.taskAttribute.dueDate = null;
         this.errorSignDate = true;
      }
   }

   setDocDelete(): void { //เปลี่ยนเวลาลบหลังเซ็น
      if (this.deletDayleft) {
         if (this.deletDayleft == 0) {
            this.deletDayleft = 1;
         }
         this.deletDayleft = parseFloat(String(this.deletDayleft));
         this.taskAttribute.retentionPeriod = this.deletDayleft;
         this.errorDocDate = false;
      } else {
         this.taskAttribute.retentionPeriod = -1;
         this.errorDocDate = true;
      }
   }

   setDateSignMin(type: String): void {
      if (type === 'sign') {
         if (!this.dateEnd) {
            this.dateEnd = this.minSelectDate;
         }
         this.errorSignDate = false;
         if (this.isSignDate) {
            this.taskAttribute.dueDate = this.dateEnd;
            this.taskAttribute.dayLeft = 1;
         } else {
            this.dateEnd = this.minSelectDate;
            this.dayLeft = 1;
            this.taskAttribute.dueDate = null;
            this.taskAttribute.dayLeft = null;
         }
      } else if (type === 'doc') {
         this.errorDocDate = false;
         if (this.isEndDate) {
            this.taskAttribute.retentionPeriod = this.deletDayleft;
         } else {
            this.deletDayleft = 1;
            this.taskAttribute.retentionPeriod = -1;
         }
      }
   }

   selectFileDoc(type: 'zDox' | 'google drive' | 'onedrive' | 'dropbox'): void {
      if (type === 'onedrive' && !localStorage.getItem('access_token')) {
         this.socialLogin.withMicrosoft().subscribe(result => {
            if(localStorage.getItem('access_token')){
               this.openDialogSelectFile(type);
            }
         }, error => {
            this.data.toast.error(error);
         });

      } else  if (type === 'google drive' && !sessionStorage.getItem('access_token_google')) {
         this.socialLogin.withGoogle().subscribe(result => {
            this.openDialogSelectFile(type);
         }, error => {
            this.data.toast.error(error);
         });

      } else  if (type === 'dropbox' && !localStorage.getItem('access_token_dropbox')) {
         this.socialLogin.withDropBox().subscribe(result => {
            this.openDialogSelectFile(type);
         }, error => {
            this.data.toast.error(error);
         });

      } else {
         this.openDialogSelectFile(type);
      }
   }

   openDialogSelectFile(type: 'zDox' | 'google drive' | 'onedrive' | 'dropbox') {
      this.zone.run(() => {
         this.selectFile = this.dialog.open(SelectFileDocumentComponent, {
            disableClose: true,
            data: this.taskAttribute.docList,
         });
         this.selectFile.componentInstance.selectFileType = type;
         this.selectFile.componentInstance.typeName = this.typeName;

         this.selectFile.afterClosed().subscribe(result => {
            if (result) {

               if(!this.validateFile(this.selectFile.componentInstance.selectedItems,true)) return;

               switch (type) {
                  case 'google drive': {
                     this.getFileGoogleDrive(this.selectFile.componentInstance.selectedItems);
                     break;
                  }
                  case 'onedrive': {
                     this.getFileOneDrive(this.selectFile.componentInstance.selectedItems);
                     break;
                  }
                  case 'dropbox': {
                     this.getFileDropBox(this.selectFile.componentInstance.selectedItems);
                     break;
                  }
                  case 'zDox': {
                     for (const document of this.selectFile.componentInstance.selectedItems) {
                        const docName = document.name;
                        const docId = document.id;
                        const object_file = document.size;
                        const type = document.mimeType;
                        const file = {
                           fullPath: "",
                           lastModified: '',
                           name: docName,
                           size: object_file,
                           type: type,
                           webkitRelativePath: ''
                        };
                        this.docNew.push(docId);
                        const objectDoclist = {
                           docId: '',
                           docName: '',
                           totalPages: '',
                           signItems: [],
                           isDocList: true,
                           isForm: false,
                           isUpload: true
                        };
                        objectDoclist.docId = docId;
                        objectDoclist.docName = docName;
                        if (docName.toLowerCase().endsWith('.zdox')) {
                           this.changeForm.emit(file.name);
                           this.taskAttribute.formName = docName;
                           this.taskAttribute.isFormStartFlow = true;
                           objectDoclist.isForm = true;
                           this.taskAttribute.formList = {
                              formName: docName,
                              formType: 'NF'
                           };
                           this.taskAttribute.docList.unshift(objectDoclist);
                           this.mimetype.unshift(file);
                           this.files.unshift({ object_file, docId, docName });
                        } else {
                           this.taskAttribute.docList.push(objectDoclist);
                           this.mimetype.push(file);
                           this.files.push({ object_file, docId, docName });
                        }
                     }
                     break;
                  }
               }
            }
         });
      });
   }

   onOptionSelected(site: any) {
      const selectedSite: Site = site;
      this.setSitewithCertificateTask(selectedSite.tin);
      this.taskAttribute.siteId = selectedSite.tin;
      this.siteId = selectedSite.tin;
      this.siteName = selectedSite.name;
      this.template = null;
      this.taskAttribute.templateName = '';
      this.getWatermark();
      this.getTemplate();
      this.getForm();
      this.clearSelectForm();
   }

   changeSelectSite(){
      this.getTemplate();
      this.getForm();
      if(this.taskAttribute.siteId == 'My Files'){
         this.setSitewithCertificateTask('My Files');
         this.selectSiteName = this.firstIndex;
      } else if (this.taskAttribute.siteId !== 'My Files') {
         for (const site of this.service.user.business) { // set site
            if (site.tin === this.taskAttribute.siteId) {
               this.clearSearch(this.siteNameList);
               this.filterSiteChanger() // clear filter select
               const selectedSite: Site = site;
               this.setSitewithCertificateTask(selectedSite.tin);
               this.siteNameList.nativeElement.value = site.name;
               this.selectSiteName = selectedSite;
            }
         }
      }
   }


   setSitewithCertificateTask(tin: string) {
      this.setTaskNameHeader(tin);
      let ischeck = false;
      if (this.certificateOrgList !== null) {
         if (this.certificateOrgList.length > 0) {
            for (let i = 0; i < this.certificateOrgList.length; i++) {
               if (this.certificateOrgList[i].certType === 'ORG') {
                  if (tin === this.certificateOrgList[i].objectName) {
                     ischeck = true;
                     break;
                  }
               }
            }
         }
      }
      if (ischeck === true) {
         this.checkcertList = '2';
         this.cerOrgDesc.nativeElement.style.visibility = 'hidden';
         this.ischeckCertOrg = true;
         this.ischeckCertPer = false;
         this.taskAttribute.siteId = tin;
         this.cerType.nativeElement.style.display = '';
         this.setCertificateHeader(this.certList[1].value);
         this.cerOrgDes.nativeElement.disabled = false;
         this.cerOrgDesc.nativeElement.disabled = false;
         this.cerOrgDes.nativeElement.style.color = '#000000';
         this.cerOrgDesc.nativeElement.style.color = '#000000';
         this.cerOrg.disabled = false;
      }
      if (ischeck === false) {
         this.checkcertList = '1';
         this.ischeckCertPer = false;
         this.ischeckCertOrg = false;
         this.cerOrgDesc.nativeElement.style.visibility = 'visible';
         this.taskAttribute.siteId = tin;
         this.cerType.nativeElement.style.display = 'none';
         this.setCertificateHeader(this.certList[0].value);
         this.cerOrgDes.nativeElement.disabled = true;
         this.cerOrgDesc.nativeElement.disabled = true;
         this.cerOrgDes.nativeElement.style.color = '#555';
         this.cerOrgDesc.nativeElement.style.color = '#555';
         this.cerOrg.disabled = true;
      }
   }

   checkCerSpecify(event: any, value: number) {
      let ischeck = false;
      if (value === 1) {
         if (event.checked === true) {
            this.setCertificateHeader(this.certList[1].value);
         } else {
            this.setCertificateHeader(this.certList[0].value);
         }
      } else {
         if (event.checked === true) {
            this.setCertificateHeader(this.certList[2].value);
         } else {
            this.setCertificateHeader(this.certList[0].value);
         }
      }
      if (ischeck === false) {
         if (this.cerOrg.checked === true && (this.cerPer.checked === true)) {
            this.setCertificateHeader(this.certList[3].value);
         } else if (this.cerOrg.checked === true && this.cerPer.checked === false) {
            this.setCertificateHeader(this.certList[1].value);
         } else if (this.cerOrg.checked === false && this.cerPer.checked === true) {
            this.setCertificateHeader(this.certList[2].value);
         }
      }
   }

   checkCertificateType(event: any) {
      if (event.value === '2') {
         this.cerType.nativeElement.style.display = '';
      } else {
         this.cerType.nativeElement.style.display = 'none';
         this.setCertificateHeader(this.certList[0].value);
         this.cerOrg.checked = false;
         this.cerPer.checked = false;
      }
   }

   setCertificateHeader(value: string) {
      this.certificateHeader = value;
      this.setNameCertificate.emit(this.getCerList(value));
      this.taskAttribute.certCode = value;
   }

   setTaskNameHeader(value: string) {
      this.setNameTask.emit(this.getSiteList(value));
   }

   getCerList(id: string) {
      if(id === ''){
         return '';
      }
      for (let i = 0; i < this.certList.length; i++) {
         if (id === this.certList[i].value) {
            return this.certList[i].viewValue;
         }
      }
   }

   getSiteList(id: string) {
      if(id === ''){
         return '';
      }
      for (const element of this.siteList) {
         if (id === element.tin) {
            this.siteNameList.nativeElement.value = element.name;
            return element.name;
         }
      }
      this.getWatermark();
      this.getForm();
   }

   getFileGoogleDrive(items: any) {
      const files: any[] = [];
      const promises: Promise<any>[] = [];

      for (const document of items) {
         const promise =  this.service.getMediaFileGoogleDrive(document.id ,document.mimeType, sessionStorage.getItem('access_token_google')).toPromise()
            .then(res => {
               const newFile = this.blobToFile(res, document.name, document.mimeType);
               files.push(newFile);
            })
            .catch(error => {
               if (error.status === 401) {
                  this.toast.error('Access token has expired or is not yet valid.');
               } else {
                  this.translate.get('uploadDoc.errorPdf').subscribe(s => {
                     this.toast.error(s);
                  });
               }
            });
         promises.push(promise);
      }

      Promise.all(promises).then(() => {
         if (this.validateFile(files)) {
            for (const file of files) {
               file.fullPath = file.webkitRelativePath;
               if (/[<|>\\\/:?*"]/g.test(file.name)) {
                  this.translate.get('alert.create_folder_error').subscribe(s => {
                     this.toast.error(s);
                  });
                  return;
               }
            }
            this.uploadDoc(files);
         }
       });
   }

   getFileOneDrive(items: any) {
      var access_token = localStorage.getItem("access_token")

      const files: any[] = [];
      const promises: Promise<any>[] = [];

      for (const document of items) {
         const promise =  this.service.oneDriveDownloadByDriveId(access_token, document.id,document.parentReference.driveId).toPromise()
            .then(res => {
               const newFile = this.blobToFile(res, document.name, document.file.mimeType);
               files.push(newFile);
            })
            .catch(error => {
               if (error.status === 401) {
                  this.toast.error('Access token has expired or is not yet valid.');
               } else {
                  this.translate.get('uploadDoc.errorPdf').subscribe(s => {
                     this.toast.error(s);
                  });
               }
            });
         promises.push(promise);
      }

      Promise.all(promises).then(() => {
         if (this.validateFile(files)) {
            for (const file of files) {
               file.fullPath = file.webkitRelativePath;
               if (/[<|>\\\/:?*"]/g.test(file.name)) {
                  this.translate.get('alert.create_folder_error').subscribe(s => {
                     this.toast.error(s);
                  });
                  return;
               }
            }
            this.uploadDoc(files);
         }
       });

   }

   getFileDropBox(items: any) {
      items = items.filter(item => {
         if (item.mimeType === 'application/octet-stream' && !item.name.toLowerCase().endsWith('.zdox')) {
            return false;
         }
         return true;
      });
      var access_token = localStorage.getItem("access_token_dropbox")

      const files: any[] = [];
      const promises: Promise<any>[] = [];

      for (const document of items) {
         const promise =  this.service.dropboxDownload(access_token, document.id,document.pathDisplay, document.name).toPromise()
            .then(res => {
               const newFile = this.blobToFile(res, document.name, document.mimeType);
               files.push(newFile);
            })
            .catch(error => {
               if (error.status === 401) {
                  this.toast.error('Access token has expired or is not yet valid.');
               } else {
                  this.translate.get('uploadDoc.errorPdf').subscribe(s => {
                     this.toast.error(s);
                  });
               }
            });
         promises.push(promise);
      }

      Promise.all(promises).then(() => {
         if (this.validateFile(files)) {
            for (const file of files) {
               file.fullPath = file.webkitRelativePath;
               if (/[<|>\\\/:?*"]/g.test(file.name)) {
                  this.translate.get('alert.create_folder_error').subscribe(s => {
                     this.toast.error(s);
                  });
                  return;
               }
            }
            this.uploadDoc(files);
         }
      });

   }

   blobToFile(theBlob: Blob, fileName: string, mimeType: string) {
      return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: mimeType });
   }

   uploadWith(type) {
      switch (type) {
         case 'my com': {
            if (this.typeName === 'template') {
               this.fileUploadTemplate.nativeElement.click();
            } else {
               this.fileUpload.nativeElement.click();
            }
            break;
         }

         case 'zDox': {
            this.selectFileDoc(type);
            break;
         }
         case 'google drive': {
            this.selectFileDoc(type);
            break;
         }
         case 'onedrive': {
            this.selectFileDoc(type);
            break;
         }
         case 'dropbox': {
            this.selectFileDoc(type);
            break;
         }
      }
   }

   clearSearch(t){
      t.value = '';
   }

   clearForm() {
      if (this.taskAttribute.docList[0]?.isForm && !this.taskAttribute.docList[0]?.isUpload) {
         this.taskAttribute.docList.splice(0,1);
      }
   }

   filterSiteChanger(){
      this.filteredOptions = this.myControlSite.valueChanges.pipe(
         startWith(''),
         map(value => {
            const name = typeof value === 'string' ? value : value?.name;
            return name ? this._filterSite(name as string) : this.siteList.slice();
         }),
      );
   }

   filterTemplateChanger(){
      this.templatesList = this.myControlTemplate.valueChanges.pipe(
         startWith(''),
         map(value => {
            const name = typeof value === 'string' ? value : value?.templateName;
            return name ? this._filterTemplate(name as string) : this.templates.slice();
         }),
      );
   }

   private _filterTemplate(name: string): TemplateData[] {
      const filterValue = name.toLowerCase();
      return this.templates.filter(template => template.templateName.toLowerCase().includes(filterValue));
   }
}

export interface TemplateData {
   templateId: number;
   templateName: string;
   createBy: string;
   active : boolean;
   siteId : string;
}

export interface Site {
   name: string;
   tin: string;
}
